import React, { Component } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { ConfirmPopUp } from '../../utils/dialogue/ConfirmPopUp';
import { servicesCategoryMap } from './servicesConstants';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty'
import findKey from 'lodash/findKey'

class FilteredServicesCard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showPopUp: false
        }
        this.onClosePopUp = this.onClosePopUp.bind(this)
    }
    
      onCardError=(e)=>{
        e.target.onerror = null; 
        e.target.src = `/images/global/personalizer/image-not-available-640.jpg`
     }


    onCardClick(selectedservice) {
        let { service, selectedGuestDetails = false } = this.props;
        if (!isEmpty(selectedGuestDetails) && selectedGuestDetails.PassengerDetail.Age < 18 && false) {
            if (selectedGuestDetails.PassengerDetail.Age <= 12 || (service.serviceGroup !== 'zspaervicesforteens' && service.serviceGroup !== 'zspaforteens')) {
                this.setState({ showPopUp: true });
                return
            }
        }
        this.props.onCardClick(selectedservice);
        this.props.history.push('/reserve');
    }

    onClosePopUp() {
        this.setState({ showPopUp: false });
    }

    render() {

        let { service, selectedGuestDetails, ShipboardCurrencyCode } = this.props;
        let WarningText = (this.state.showPopUp) ? 'Due to age restrictions ' + service.treatmentDesc + ' is not available for ' + selectedGuestDetails.PassengerDetail.Name.FirstName + ' ' + selectedGuestDetails.PassengerDetail.Name.LastName : '';
        let category = findKey(servicesCategoryMap, (item) => item === service.serviceGroup) || service.serviceGroup;
        let imageUrl = `${process.env.imageUrl}/${service.treatmentId}.jpg`;
        return (
            <div style={{ width: '100%' }} className='filtered-card-container'>
                <Card data-test-id='card-one-up' className='img-responsive-wrapper card-col'>
                    <Row >
                        <Col className="col-md-4" >
                            <Card.Img onClick={this.onCardClick.bind(this, service)} className='filtered-card-img' data-test-id="card-image" variant="left" src={imageUrl}
                                onError={this.onCardError} />
                        </Col>
                        <Col className="col-md-5 filtered-card-content"  >
                            <h3 tabindex="0" className="filtered-card-title font-size-p10 title-hover" data-test-id="card-services-title" onClick={this.onCardClick.bind(this, service)} >{service.treatmentDesc}</h3>
                            <p data-test-id="card-services-category" className='filtered-card-category-text font-size-p2 gotham-xn-medium'>{category}</p>
                            <Card.Text >
                                <p className="font-size-p2 gotham-book">{service.shortDescription}</p>
                            </Card.Text>
                        </Col>
                        <Col className="col-lg-2 col-md-3 filtered-card-right" >

                            <div className='price-container vertical-line'>
                                <div className='filtered-price-label margin-left-20px'>
                                    <span className="font-size-p4 gotham-xn-medium"> from </span>
                                    <div>
                                        <span><sup className='font-size-p2 gotham-xn-medium card-price'>{`${ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} `}</sup>  </span>
                                        <span style={{ fontSize: '32px' }} className='gotham-xn-medium' data-test-id="card-price">
                                            {service.price}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>

                    <Card.Footer className='filtered-card-footer'>
                        <Row>
                            <Col className='filtered-card-footer-label' md={9}>
                                {service.serviceGroup !== 'zspaervicesforteens' && service.serviceGroup !== 'zspaforteens' &&
                                    <span data-test-id='spa-age-warning' className='age-warning-text red'>
                                        This spa reservation is only available for guests over 18 years of age.</span>
                                }
                            </Col>
                            <Col md={3} className='filtered-card-button-container col-md-pad-0'>
                                <button onClick={this.onCardClick.bind(this, service)}
                                    aria-label={`Reserve Now - ${service.treatmentDesc} from $ ${service.price}`}
                                    className="button primary-btn font-size-p5 gotham-xn-medium  filtered-card-btn" data-test-id="reserve-now" >Reserve Now</button>
                            </Col>
                        </Row>
                    </Card.Footer>
                </Card>
                {this.state.showPopUp ?
                    <ConfirmPopUp title='Information' contentText={WarningText} isCancel={false} onConfirm={this.onClosePopUp} onClose={this.onClosePopUp} show={this.state.showPopUp} /> :
                    null
                }

            </div>
        );
    }
}



export default withRouter(FilteredServicesCard);